/* Firm membership for the signed-in user (cached per token so every page doesn't refetch). */
import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@/App";

const API = process.env.REACT_APP_BACKEND_URL;
const cache = { token: null, promise: null, value: null };

export const loadFirm = (token, force = false) => {
  if (!token) return Promise.resolve(null);
  if (!force && cache.token === token && cache.promise) return cache.promise;
  cache.token = token;
  cache.promise = axios.get(`${API}/api/legacy/firm`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => { cache.value = r.data; return r.data; }).catch(() => { cache.value = null; return null; });
  return cache.promise;
};

export const useFirm = () => {
  const { token } = useAuth();
  const [info, setInfo] = useState(cache.token === token ? cache.value : null);
  const [loading, setLoading] = useState(!(cache.token === token && cache.value));
  useEffect(() => { let on = true; loadFirm(token).then((v) => { if (on) { setInfo(v); setLoading(false); } }); return () => { on = false; }; }, [token]);
  const reload = () => loadFirm(token, true).then((v) => { setInfo(v); return v; });
  const ACCT_KEY = `tp.acctView.${info?.firm?.id || "none"}`;
  return { info, firm: info?.firm || null, role: info?.role || null, isMember: !!info?.firm, loading, reload, ACCT_KEY };
};

export const getAcctView = (key) => localStorage.getItem(key) !== "0";
